"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendCustomerData = void 0;
var _getCustomerData = require("./getCustomerData");
// istanbul ignore file @preserve -- Calling Genesys API

const sendCustomerData = customerDataParams => {
  // eslint-disable-next-line new-cap -- Genesys preset naming
  window.Genesys?.('command', 'Database.set', {
    messaging: {
      customAttributes: (0, _getCustomerData.getCustomerData)(customerDataParams)
    }
  });
};
exports.sendCustomerData = sendCustomerData;